import axios from "../../axiosMiddleware";
import { api } from "../../apiendpoints/index";
import { da } from "date-fns/locale";

export const AddOrEditShift = async (request) => {
  return axios.post(api.ASAI_ADMIN.ADD_OR_EDIT_SHIFT, request);
};

export const AddOrEditLeaveType = async (request) => {
  return axios.post(api.ASAI_ADMIN.ADD_OR_EDIT_LEAVE_TYPE, request);
};

export const GetAllLeaveType = async () => {
  return axios.get(api.ASAI_ADMIN.GET_ALL_LEAVE_TYPE);
};

export const AddOrEditLeaveBalance = async (request) => {
  return axios.post(api.ASAI_ADMIN.ADD_OR_EDIT_LEAVE_BALANCE, request);
};

// Annual opening-balance import. The backend endpoint is ImportLeaveBalanceYearly.
export const ImportLeaveBalanceYearly = async (request) => {
  return axios.post(api.ASAI_ADMIN.IMPORT_LEAVE_BALANCE_YEARLY, request);
};

export const AddOrEditMachine = async (request) => {
  return axios.post(api.ASAI_ADMIN.ADD_OR_EDIT_MACHINE, request);
};

export const GetMachineDepartments = async () => {
  return axios.get(api.ASAI_ADMIN.GET_MACHINE_DEPARTMENTS);
};

export const AddOrEditOrganization = async (request) => {
  return axios.post(api.ASAI_ADMIN.ADD_OR_EDIT_ORGANIZATION, request);
};

export const GetAllLeaveSheetEmployeeDetailsDropdowns = async (
  getAllEmployees = false,
  isPayrollEmployee = false,
  contractAgency ,
  config = {},
) => {
  return axios.get(
    `${api.ASAI_ADMIN.EMP_GET_ALL_EMPLOYEE_LEAVE_SHEET_DETAILS_DROPDOWNS}?getAllEmployees=${getAllEmployees}&isPayrollEmployee=${isPayrollEmployee}&contractAgency=${contractAgency}`,
    config,
  );
};
export const GetEmployeeAttendanceAndLeaveDetails = async (data) => {
  
  return axios.post(
    api.ASAI_ADMIN.GET_EMPLOYEE_ATTENDANCE_AND_LEAVE_DETAILS,data
  );
};

export const DownloadFtoPDF = async (id) => {
  return axios.get(
    `${api.ATTENDANCE_CHANGE.DOWNLOAD_FTO}/${id}`,
    {
      responseType: "blob",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
};


export const AddOrEditShiftWiseRuleConfiguration = async (request) => {
  return axios.post(
    api.ASAI_ADMIN.ADD_OR_EDIT_SHIFT_WISE_RULE_CONFIGURATION,
    request,
  );
};

export const AddOrEditAttendanceBonusRule = async (request) => {
  return axios.post(
    api.ASAI_ADMIN.ADD_OR_EDIT_ATTENDANCE_BONUS_RULE,
    request
  );
};


export const GetMachineTypes = async () => {
  return axios.get(
    api.ASAI_ADMIN.GET_MACHINE_TYPES
  );
};
